import { Button, Modal, ModalClose, ModalContent, ModalTitle } from '@/components/ui';
import {
  bulkIssueAllMobileModalBody,
  bulkIssueSingleMobileModalBody,
  bulkIssueSingleMobileModalTitle,
} from '@/config/bulkUserImportFlow';

interface BulkIssueMobileCredentialModalProps {
  open: boolean;
  mobileCount: number;
  issueTarget?: { firstName: string; lastName: string } | null;
  onCancel: () => void;
  onConfirm: () => void;
}

export function BulkIssueMobileCredentialModal({
  open,
  mobileCount,
  issueTarget,
  onCancel,
  onConfirm,
}: BulkIssueMobileCredentialModalProps) {
  const isSingle = Boolean(issueTarget);
  const title = isSingle
    ? bulkIssueSingleMobileModalTitle(issueTarget!.firstName, issueTarget!.lastName)
    : 'Issue all mobile credentials?';
  const body = isSingle
    ? bulkIssueSingleMobileModalBody(issueTarget!.firstName, issueTarget!.lastName)
    : bulkIssueAllMobileModalBody(mobileCount);

  return (
    <Modal open={open} onOpenChange={(next) => !next && onCancel()}>
      <ModalContent className="ui-modal ui-modal--bulk-issue">
        <div className="ui-modal__header">
          <ModalTitle className="ui-modal__title">{title}</ModalTitle>
          <ModalClose className="ui-modal__close" aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 16 16" fill="none" aria-hidden>
              <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </ModalClose>
        </div>

        <p className="bulk-import__issue-modal-body">{body}</p>

        <div className="ui-modal__footer bulk-import__issue-modal-footer">
          <Button type="button" variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="button" onClick={onConfirm}>
            {isSingle ? 'Issue credential' : 'Issue all'}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
}

/** @deprecated Use BulkIssueMobileCredentialModal */
export const BulkIssueAllMobileModal = BulkIssueMobileCredentialModal;
